import { Injectable, inject } from '@angular/core';
import { SiaEmailApi } from '../apis/sia-email.api';
import { SiaSessionParam } from '../interfaces/sia-session-param';

@Injectable({
  providedIn: 'root',
})
export class EmailService {
  private emailApi = inject(SiaEmailApi);

  /** Inserted by Angular inject() migration for backwards compatibility */

  constructor() {}

  sendWithTemplate(
    to: string | string[],
    templateName: string,
    parameters: SiaSessionParam[],
    attachmentsFolder?: string,
    subject?: string,
  ): Promise<boolean>;
  sendWithTemplate(
    to: string | string[],
    templateName: string,
    parameters: SiaSessionParam[],
    attachmentsFolder?: string[],
    subject?: string,
  ): Promise<boolean>;
  sendWithTemplate(
    to: string | string[],
    templateName: string,
    parameters: SiaSessionParam[],
    attachmentsFolder?: string | string[],
    subject?: string,
  ): Promise<boolean> {
    const recipients = Array.isArray(to) ? to : to ? [to] : [];
    if (!recipients.length) {
      return Promise.resolve(false);
    }
    if (!templateName) {
      return Promise.resolve(false);
    }
    const payload: any = {
      to: recipients,
      templateName,
      subject,
      parameters: parameters ?? [],
    };
    if (Array.isArray(attachmentsFolder)) {
      payload.attachmentsFolders = attachmentsFolder;
    } else if (attachmentsFolder !== undefined) {
      payload.attachmentsFolder = attachmentsFolder;
    }
    return this.emailApi.sendWithTemplate(payload).catch((e: any) => {
      console.error(e);
      return false;
    });
  }
}
